module.exports = "<ion-header>\n  <ion-toolbar>\n    <ion-title>phonepe</ion-title>\n  </ion-toolbar>\n</ion-header>\n\n<ion-content>\n\n</ion-content>\n"